<template>
    <div class="header">
      <img src="@/assets/logo.svg" alt="">
      <div class="header-content wrapper">
        <h1>360攻击欺骗防御系统</h1>
        <p>行业定制高仿真欺骗，保护企业真实资产，溯源攻击者</p>
        <button @click="download">查看白皮书</button>
        <!-- <a href="mailto:contactus@360.cn"></a> -->
      </div>
    </div>
</template>
<script>
export default {
  methods: {
    download() {
      const name = "mailto:contactus@360.cn"
      let a = document.createElement("a")
      a.setAttribute("href", name)
      // a.setAttribute("download", name)
      document.body.appendChild(a)
      a.click()
      a.remove()
    }
  }
}
</script>
<style>
.header{
    background: url('../assets/bg.jpeg');
    height: 700px;
    background-position: 70% center;
    background-size: cover;
    position: relative;
}
.header-content{
  color: #fff;
  padding-top: 100px;
}
.header img{
  margin: 10px 0 0 10px;
}
.header-content h1{
  font-size: 4rem;
  letter-spacing: 0;
  padding-top: 200px;
}
.header-content p{
  font-size: 2rem;
  margin: 50px 0 50px 0;
}
.header-content button{
  width: 180px;
  height: 48px;
  border: 1px solid #FFFFFF;
  background: transparent;
  color: #fff;
  font-size: 20px;
}
.header-content button:hover{
  background: #FFF;
  cursor: pointer;
  color: #0083FF;
}
</style>
